import {TicketType} from './ticketType';

export class TicketSignup
{
    public ticketType: TicketType;
    
    public static fromTicketType(ticketType: TicketType): TicketSignup
    {
        return Object.assign(new TicketSignup(), {
            ticketType: { id: ticketType.id }
        });
    }
}